// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function FormView(Props) {
  let onSubmit = Props.onSubmit;
  let initialFocusRef = Props.initialFocusRef;
  let action = Props.action;
  let method__ = Props.method_;
  let encType = Props.encType;
  let className = Props.className;
  let children = Props.children;
  React.useEffect((function () {
    if (initialFocusRef !== undefined) {
      const __x = initialFocusRef.current;
      Belt__Belt_Option.map((__x == null) ? undefined : Caml_option.some(__x), (function (el) {
        return el.focus();
      }));
    }
    
  }), []);
  let tmp = {
    children: children,
    onSubmit: (function (ev) {
      if (Belt__Belt_Option.isSome(action)) {
        return;
      } else {
        Curry._1(onSubmit, undefined);
        ev.preventDefault();
        return;
      }
    })
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  if (action !== undefined) {
    tmp.action = Caml_option.valFromOption(action);
  }
  if (encType !== undefined) {
    tmp.encType = Caml_option.valFromOption(encType);
  }
  if (method__ !== undefined) {
    tmp.method = Caml_option.valFromOption(method__);
  }
  return JsxRuntime.jsx("form", tmp);
}

const make = FormView;

export {
  make,
}
/* react Not a pure module */
